import { useAppToastStore } from '@/state/appToastStore';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const AUTO_DISMISS_MS = 3500;

/**
 * Global toast region (yodlee-id-portal `Toast.jsx` parity): fixed position, portal to `document.body`,
 * auto-dismiss, dismiss button, aria-live.
 */
export function ToastRegion() {
  const toast = useAppToastStore(s => s.toast);
  const dismissToast = useAppToastStore(s => s.dismissToast);

  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => dismissToast(), AUTO_DISMISS_MS);
    return () => window.clearTimeout(t);
  }, [toast, dismissToast]);

  if (!toast) return null;

  const top = toast.placement === 'top';
  const isError = toast.variant === 'error';

  const node = (
    <div
      className={`toastRegion${top ? ' toastRegion--top' : ''}`}
      aria-live={isError ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <div className={`toast${isError ? ' toast--error' : ''}`} role={isError ? 'alert' : 'status'}>
        <div>
          <div className="toastTitle">{toast.title}</div>
          {toast.message ? <div className="toastText">{toast.message}</div> : null}
        </div>
        <button
          type="button"
          className="iconBtn"
          aria-label="Dismiss notification"
          onClick={dismissToast}
          style={{ height: 40, width: 40 }}
        >
          ✕
        </button>
      </div>
    </div>
  );

  return createPortal(node, document.body);
}
